<template>
  <div class="text-center">
    <v-dialog
      v-model="showDialog"
      width="700"
    >
      <v-card>
        <v-card-title class="pa-0">
          <v-toolbar
            color="primary"
            dark
            flat
          >
            <v-toolbar-title>{{ t('landingpage.information-button.title') }}</v-toolbar-title>
            <v-spacer />
            <v-toolbar-items>
              <v-btn
                icon
                @click="$emit('dialog-closed')"
              >
                <v-icon size="large"> mdi-close </v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
        </v-card-title>

        <v-card-text class="mt-5">
          <p>{{ t('landingpage.information-button.content') }}</p>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="black"
            variant="text"
            @click="$emit('dialog-closed')"
          >
            {{ t('labels.close') }}
          </v-btn>
          <v-btn
            v-if="helpLinks.customUrl"
            variant="text"
            color="primary"
            class="ml-2"
            :href="helpLinks.customUrl"
            target="_blank"
            rel="noopener noreferrer"
            @click="$tracking.event('Landingpages', 'Clicked', 'Custom Url')"
          >
            {{ t('landingpage.information-button.link-text') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script lang="ts" setup>
import { getCurrentInstance, ref } from 'vue'
import { useI18n } from 'vue-i18n'

import helpLinks from '@/lib/helpLinks'

defineEmits(['dialog-closed'])
const instance = getCurrentInstance()
const $tracking = instance?.proxy?.$tracking
const { t } = useI18n()

const showDialog = ref(true)
</script>
